import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'

export const RouterLink = styled(Link)`
  ${({ color }) => css`
    color: var(${color});
    text-decoration: none;
  `}
`
